import {postBodyService,getService} from "./base.service";
import config from "../config/application";

//url
const list = 'channelTransaction/list';
const find = 'channelTransaction/findByEntity';
const add = 'channelTransaction/add';
const update = 'channelTransaction/update';
const deleteUrl = 'channelTransaction/delete';

class ChannelTransactionService {
    getChannelTransactions() {
        const url = `${config.data.income.channelTransaction.url}${list}`;
        return getService(url);
    }
    saveChannelTransaction(channelTransaction) {
        const url = `${config.data.income.channelTransaction.url}${add}`;
        return postBodyService(url,channelTransaction);
    }
    updateChannelTransaction(channelTransaction) {
        const url = `${config.data.income.channelTransaction.url}${update}`;
        console.log(url,channelTransaction)
        return postBodyService(url,channelTransaction);
    }
    deleteChannelTransaction(channelTransactions) {
        const url = `${config.data.income.channelTransaction.url}${deleteUrl}`;
        return postBodyService(url,channelTransactions);
    }
    findByEntity(entity) {
        const url = `${config.data.income.channelTransaction.url}${find}/${entity}`;
        return getService(url);
    }
}
export default new ChannelTransactionService(); 